import React from "react";
import { Navigate } from "react-router-dom";
import { hasAnyPermission, hasPermission } from "../utils/permissoes";
import { clearAuthSession, isTokenExpired } from "../services/api";

const PrivateRoute = ({ children, token, permission, anyPermission }) => {
  if (!token || isTokenExpired(token)) {
    clearAuthSession();
    return <Navigate to="/login" replace />;
  }
  if (permission && !hasPermission(token, permission)) {
    return <Navigate to="/home" replace />;
  }

  if (anyPermission?.length && !hasAnyPermission(token, anyPermission)) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default PrivateRoute;
